import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, RadioCardOptionGroup } from '..';
import { LifeDocumentIntroHeader } from '../../pages';

const planOptions = [
  {
    id: 'monthly',
    label: 'Monthly',
    value: 'monthly',
    description: '$24.99/month',
    name: 'monthly_plan'
  },
  {
    id: 'annual',
    label: 'Annual',
    value: 'annual',
    description: '$199.99/year',
    name: 'annual_plan'
  }
];

export default function SignupPlanScreen() {
  const navigate = useNavigate();

  const handleNext = useCallback(() => {
    navigate('/signup/payment');
  }, [ navigate ]);

  return (
    <div className="signup-plan-screen">
      <LifeDocumentIntroHeader
        icon="credit_card" 
        title="Select your plan"
        description="Select the plan that best suits your needs."
      />
      <RadioCardOptionGroup
        options={planOptions}
      />
      <ButtonBar
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}